import { useQuery } from "@tanstack/react-query";
import { MY_HARDWARE_QUERY_KEY } from "@/services/my-hardware/my-hardware.constants";
import { createMyHardwareService } from "@/services/my-hardware/my-hardware-service.factory";
import type { MyHardwareSnapshot } from "@/services/my-hardware/my-hardware.types";

const MY_HARDWARE_STALE_TIME_MS = 30_000;

const myHardwareService = createMyHardwareService();

export const useMyHardware = ({ enabled = true }: { enabled?: boolean } = {}) => {
  return useQuery<MyHardwareSnapshot, Error>({
    queryKey: MY_HARDWARE_QUERY_KEY,
    queryFn: () => myHardwareService.getMyHardware(),
    staleTime: MY_HARDWARE_STALE_TIME_MS,
    enabled,
  });
};
